<script lang="ts">
  import PreviewInfoModal from "@retailer/svelte/RetailerPreview/PreviewInfoModal.svelte";
  import { open as openPreviewModal } from "@retailer/svelte/stores/PreviewInfoModalStore";
  import { HttpPromise } from "@shared/svelte/Modules/ApiService";

  export let retailer;

  const exitPreview = async () => {
    const options = {
      method: "POST",
      url: "/api/retailer/retailers/exit_sales_rep_preview",
    };

    await HttpPromise(options);
    window.location.reload();
  };

  openPreviewModal();

</script>

<PreviewInfoModal salesRepPreview={true} />
<div class="fizz-styles">
  <div class="fizz-inset-squish-16 fizz-space-between fizz-text-inverse fizz-surface-gray-inverse">
    <p>Previewing zip code: {retailer.zip}</p>
    <button class="fizz-button-small" on:click={() => exitPreview()}>Exit Retailer Preview</button>
  </div>
</div>
